import { Injectable } from '@angular/core';
import { environment } from '@asset-old/env/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

declare global {
  interface Window {
    ItauDigitalAnalytics: any;
  }
}

@Injectable({
  providedIn: 'root',
})

/*
  A classe GA4AnalyticsService fornece métodos para rastrear eventos, definir propriedades do usuário e definir parâmetros padrão para o Google Analytics 4.
 */
export class GA4AnalyticsService {
  constructor() {}

  /**
    Verifica se o CDN do Google Analytics 4 foi carregado na página e retorna um Observable com o resultado da verificação.
    @returns Um Observable com o resultado da verificação.
    IMPORTANTE: lembrando que em ambiente de desenvolvimento 
   */
  checkCDNLoaded(): Observable<null> {
    return new Observable<null>((observer) => {
      const interval = setInterval(() => {
        if (window.ItauDigitalAnalytics) {
          observer.next(null);
          observer.complete();
          clearInterval(interval);
        }
      }, 100);

      return () => clearInterval(interval);
    }).pipe(
      // timeout de 5 segundos para o observable retornar erro caso o CDN não seja carregado
      timeout(5000),
      catchError((err) => {
        return throwError(() => err);
      })
    );
  }

  /** 
    @param params Um objeto que contém o nome do evento e os parâmetros a serem rastreados.
   */

  trackEvent(params: Object): void {
    // Exemplo de params de trackEvent
    /*  
   {
      analytics: {
        "event_name": "click",
        "parameters": {
          "custom_path": "/reneg-nao-logado/meus-acordos",
          "implementation_team": "renegociacao-nao-logado:e-commerce",
          "detail": "botao:mais-opcoes"
        }
      }
    }    
    */

    this.checkCDNLoaded().subscribe({
      next: () => {
        if (window?.ItauDigitalAnalytics?.trackEvent) {
          window.ItauDigitalAnalytics.trackEvent(params);
          //console.log('sucesso - trackEvent enviou:', params);
        }
      },
      error: (err) => {
        if (!environment.testing) {
          console.error('Erro ao carregar CDN do GA4');
        }
      },
    });
  }

  /**
    @param params Um objeto que contém as propriedades do usuário a serem definidas.
   */

  // IMPORTANTE: Esse método só pode ser utilizado em um projeto 100% Angular
  // setUserProperties(params: Object): void {
  //   // Exemplo de user de userProperties
  //   /*
  //    {
  //      analytics: {
  //        user: {
  //          user_id: 894232,
  //          outras props aqui...
  //        }
  //      }
  //    }
  //    */

  //   this.checkCDNLoaded().subscribe({
  //     next:() => {
  //       if (window?.ItauDigitalAnalytics?.setUserProperties) {
  //         window.ItauDigitalAnalytics.setUserProperties(params);
  //         console.log('sucesso - setUserProperties enviou: ', params);
  //       } else {
  //         console.log('Erro ao taguear objeto: ', params);
  //       }
  //     }, error: (err) => {
  //       console.error('Erro ao carregar CDN do GA4');
  //     }
  //   });
  // }

  /**
    @param params Um objeto contendo os parâmetros padrões a serem definidos.
   */
  // IMPORTANTE: Esse método só pode ser utilizado em um projeto 100% Angular
  defaultParameters(params: Object): void {
    // Exemplo de params de defaultParameters

    /*
     {
       analytics: {
         parameters: {
           business: 'valor-do-canal',
           business_channel: 'valor-do-canal',
           environment: 'nao-logado'
         }
       }
     }
     */

    this.checkCDNLoaded().subscribe({
      next: () => {
        if (window?.ItauDigitalAnalytics?.setDefaultParameters) {
          window.ItauDigitalAnalytics.setDefaultParameters(params);
          //console.log("sucesso - setDefaultParameters enviou:", params);
        } else {
          //console.log("Erro ao taguear objeto: ", params);
        }
      },
      error: (err) => {
        if (!environment.testing) {
          console.error('Erro ao carregar CDN do GA4');
        }
      },
    });
  }
}
